<ng-container *ngIf="summary$ | async as summary">
    <ng-container *ngIf="campaign$ | async as campaign">
        <div
            class="position-relative currently-live__campaign"
            *ngIf="isNotEmpty(campaign)"
        >
            <div class="position-absolute h-100 w-100 currently-live__background"></div>
            <div class="d-flex h-100 w-100 currently-live__content">
                <div
                    class="currently-live__campaign-name text-left w-50"
                >
                    <div class="currently-live__campaign-name--title">Campaign</div>
                    <div class="currently-live__campaign-name--value text-truncate">{{ campaign.name }}</div>
                </div>
                <div
                    class="currently-live__campaign-raised text-right w-50"
                >
                    <div class="currently-live__campaign-raised--title">Raised</div>
                    <div class="currently-live__campaign-raised--value text-truncate">{{ calculateRaisedValue(summary, campaign) | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>